import { call, put, select } from 'redux-saga/effects';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { backendClient } from '../../../services/api/backend-client';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { getFileData } from '../../../browser/filePicker';

export function* submitFeedbackSaga(action) {
  try {
    const { feedbackTitle, feedbackText, selectedFiles } = action.payload;

    const form = new FormData();
    form.append('feedbackTitle', feedbackTitle);
    form.append('feedbackText', feedbackText);

    // Convert file paths -> Blob for upload
    for (const f of selectedFiles || []) {
      const fileData = yield call(getFileData, f.path);
      const blob = new Blob([new Uint8Array(fileData.buffer)], {
        type: fileData.mime || 'application/octet-stream',
      });
      form.append('files', blob, fileData.name || f.name || 'attachment');
    }

    const { data } = yield call(
      [backendClient, backendClient.post],
      '/support/feedback',
      form
    );


    if (data?.success) {
      yield put(showSnackbar({ message: 'Feedback submitted successfully.', severity: 'success' }));
    } else {
      throw new Error(data?.error || 'Unknown error');
    }
  } catch (error) {
    console.error('Error submitting feedback:', error);
    yield put(showSnackbar({ message: 'Failed to submit feedback. Please try again.', severity: 'error' }));
  }
}